import { ID } from './id';
import { Timestamp } from './timestamp';

export type SectionItemBase = {
  id: ID;
};

export type SectionBase<Item extends SectionItemBase> = {
  id: ID;
  items: Item[];
};

export type DateSection<Item extends SectionItemBase> = SectionBase<Item> & {
  startDate: Timestamp;
  endDate: Timestamp;
};

export enum DateSectionOptions {
  Day = 'day',
  RestOfMonth = 'rest-of-month',
  Month = 'month',
  Year = 'year',
}

export const overdueSectionID = 'overdue';

export type OverdueSectionID = typeof overdueSectionID;

export const otherSectionID = 'other-section';

export type OtherSectionID = typeof otherSectionID;

export const goalInboxID = 'inbox';

export type GoalInboxID = typeof goalInboxID;

export const lifeAreaOtherID = 'other';

export type LifeAreaOtherID = typeof lifeAreaOtherID;

export const goalOtherID = 'other';

export type GoalOtherID = typeof goalOtherID;

export const unlinkedPlannedTasksID = 'unlinked-planned-tasks';

export type UnlinkedPlannedTasksID = typeof unlinkedPlannedTasksID;

export const untaggedId = 'untagged';

export type UntaggedId = typeof untaggedId;

export const noTagId = 'noTag';

export type NoTagId = typeof noTagId;

export const noDeadlineSectionID = 'no-deadline';

export type NoDeadlineSectionID = typeof noDeadlineSectionID;

export const completedSectionID = 'completed';

export type CompletedSectionID = typeof completedSectionID;

export const goalsCompletedSectionID = 'completed-goals-section';

export type GoalsCompletedSectionID = typeof goalsCompletedSectionID;

export const goalsArchivedSectionID = 'archived-goals-section';

export type GoalsArchivedSectionID = typeof goalsArchivedSectionID;

export const noGroupingId = 'noGrouping';

export type NoGroupingId = typeof noGroupingId;

export const newTaskSuffix = '-new-task';

export type NewTaskSuffix = typeof newTaskSuffix;

export const upcomingRestOfMonthPrefix = 'rom:';

export type UpcomingRestOfMonthPrefix = typeof upcomingRestOfMonthPrefix;

export const upcomingMonthPrefix = 'month:';

export type UpcomingMonthPrefix = typeof upcomingMonthPrefix;

export const upcomingYearPrefix = 'year:';

export type UpcomingYearPrefix = typeof upcomingYearPrefix;
